import EmptyRequest from './EmptyRequest.view';
export default EmptyRequest;
